/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import CommonContext from "../../hooks/commonContext";
import { Container } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import styles from "./clients.module.scss";
import { useEffect } from "react";
import {
  deleteInvitedUsers,
  getClientsList,
  updateClientStatus,
} from "../../services/apiservices/client";
import { useMediaQuery } from "@mui/material";
import { getAllEmployee } from "../../services/apiservices/employee";
import AuthContext from "../../hooks/authContext";
import DesktopClientTable from "./DekstopViewClients";
import MobileViewClientTable from "./MobileViewClients";
import { useTheme } from "@mui/material/styles";
import { Plus, Search } from "lucide-react";
import { Input } from "../../components/ui/input";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import { useToast } from "../../hooks/useToast";
import { trackEvent, CMS_EVENTS } from "../../services/apiservices/analytics";

const Clients = (_props) => {
  // eslint-disable-next-line no-unused-vars
  const commonContext = useContext(CommonContext);
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [allClients, setAllClients] = React.useState([]);
  const [inActiveData, setInactiveData] = React.useState([]);
  const [pendingData, setPendingData] = React.useState([]);
  const [activeData, setActiveData] = React.useState([]);
  const [searchTerm, setsearchTerm] = React.useState("");
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = React.useState(false);
  const [statusFilter, setStatusFilter] = React.useState("active");
  const theme = useTheme();
  const { toast } = useToast();
  // eslint-disable-next-line no-unused-vars
  const isDarkMode = theme.palette.mode === "dark";

  const statusFilters = [
    { label: "All", value: "all" },
    { label: `Active (${activeData?.length || 0})`, value: "active" },
    { label: `Inactive (${inActiveData?.length || 0})`, value: "inactive" },
    { label: `Pending (${pendingData?.length || 0})`, value: "pending" },
  ];

  const fetchClientsList = async () => {
    setIsLoading(true);

    try {
      const [employeeRes, clientRes] = await Promise.all([
        new Promise((resolve) => getAllEmployee(resolve)),
        new Promise((resolve) => getClientsList({}, resolve)),
      ]);

      let filterClientData = [];

      if (auth.userProfile.role !== "superUser") {
        const Id =
          auth.userProfile.role === "companyUser"
            ? auth.userProfile.id
            : auth.userProfile.companyId;
        filterClientData = clientRes?.filter((item) => item.companyId === Id);
      } else {
        filterClientData = clientRes;
      }

      const empData =
        employeeRes?.data?.filter((item) => item.role === "companyUser") || [];

      const setallclientData = filterClientData?.map((rcitem) => {
        const primarycontact =
          rcitem?.contact?.find((citem) => citem?.type === "primary") || {};
        const companyName = empData?.find(
          (item) => item.id === rcitem.companyId
        );

        return {
          ...rcitem,
          clientNumbers: String(rcitem?.clientNumber).padStart(4, "0"),
          clientId: rcitem.id,
          primaryContact: primarycontact.mobileNumber,
          email: primarycontact.email,
          company: companyName
            ? `${companyName?.companyName}`
            : null,
        };
      });

      let sortedData = sortingFunction(setallclientData);
      const activeData = sortedData?.filter((item) => item.status === true);
      const inActiveData = sortedData?.filter((item) => item.status !== true && item?.shiftData && Object.keys(item?.shiftData)?.length > 0);
      const pendingData = sortedData?.filter((item) => item.status !== true && (!item?.shiftData || Object.keys(item?.shiftData)?.length === 0));
      setActiveData(activeData);
      setInactiveData(inActiveData);
      setPendingData(pendingData);
      setAllClients(sortedData);
    } catch (error) {
      console.error("Error fetching clients:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const sortingFunction = (data) => {
    const result = data?.sort((a, b) => {
      if (a.clientNumbers < b.clientNumbers) return -1;
      if (a.clientNumbers > b.clientNumbers) return 1;

      if (a.email < b.email) return -1;
      if (a.email > b.email) return 1;

      return 0;
    });

    return result;
  };

  useEffect(() => {
    fetchClientsList();
  }, []);

  // eslint-disable-next-line no-unused-vars
  const handleFilterChange = (event, newValue) => {
    if (newValue !== null) {
      setStatusFilter(newValue);
    }
  };

  const OnSwitchChange = async (rowitem, newstatus) => {
    setIsLoading(true);
    const updateRes = await updateClientStatus(rowitem, newstatus);
    if (updateRes?.status) {
      if (newstatus === false) {
        const invitedEmails = (rowitem?.contact || [])?.filter(c => c.invite)?.map(c => c.email);
        if (invitedEmails?.length > 0) {
          deleteInvitedUsers(invitedEmails);
        }
      }
      toast?.({ title: "Success", description: `Client Status Updated Successfully` });
      fetchClientsList();
      trackEvent(CMS_EVENTS.CLIENT_UPDATED, {
        user_id: auth?.userProfile?.id,
        client_id: rowitem?.id,
        status: newstatus ? "active" : "inactive",
      });
    } else {
      console.error("Failed to update:", updateRes.error);
    }
    setIsLoading(false);
  };
  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.clientNumbers)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.email)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.company)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.clientName)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.primaryContact)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase())
    );
  };

  const updatedClients =
    statusFilter === "active"
      ? activeData
      : statusFilter === "inactive"
        ? inActiveData
        : statusFilter === "pending"
          ? pendingData
          : allClients;
  const filteredList =
    searchTerm !== ""
      ? updatedClients?.filter((item) => checkRowSearch(searchTerm, item))
      : updatedClients;

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Clients"
          showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Clients" }]}
          BreadCrumbCurrentPageTitle={"Manage"}
          showLastSeen={true}
          buttonTitle="Add New Client"
          icons={<Plus className="h-4 w-4 mr-5" />}
          buttonClass={"d-flex flex-center"}
          buttonStyle={{
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          }}
          buttonClick={() => { navigate("/peoples/createClient"); auth?.setNewClientId(); }}
        />

        <div className={isMobile ? "" : "p-24"}>
          <div style={{ margin: "0px auto" }}>
            <div
              className={
                isMobile
                  ? "d-flex flex-direction-column pv-15 ph-12"
                  : "d-flex flex-space-between flex-center mb-20"
              }
            >
              <div>
                <div
                  className="text-foreground"
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                  }}
                >
                  Client Management
                </div>
                <div
                  className="mv-10"
                  style={{ fontSize: "16px", color: "#6B7280" }}
                >
                  View and manage your clients
                </div>
              </div>
            </div>
            <div
              className={isMobile ? "ph-10" : `sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
              style={{
                borderRadius: "8px",
                // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
              }}
            >
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column w-100"
                    : "d-flex flex-center flex-space-between"
                }
              >
                <div
                  className={`${styles.searchFieldWrapper} mt-5`}
                  style={{
                    maxWidth: isMobile ? "" : "65%",
                    marginBottom: isMobile ? "10px" : "",
                  }}
                >
                  <div className="relative mb-12">
                    <Search
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                      size={18}
                    />
                    <Input
                      placeholder="Search clients..."
                      className="pl-40 bg-white dark:bg-[#0F1729]"
                      value={searchTerm ? searchTerm : ""}
                      onChange={(event) => {
                        setsearchTerm(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <div
                  className={
                    isMobile
                      ? "d-flex flex-direction-column"
                      : "d-flex flex-center"
                  }
                >
                  <div
                    className={isMobile ? "" : "ml-15"}
                    style={{ width: isMobile ? "400px" : "200px" }}
                  >
                    <SingleSelectNew
                      id="types"
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder="Types"
                      options={statusFilters}
                      onChange={(value) => {
                        setStatusFilter(value);
                      }}
                      value={statusFilter ? statusFilter : ""}
                    />
                  </div>
                </div>
              </div>

              {!isMobile && !isLandscape && (
                <DesktopClientTable
                  clients={filteredList}
                  OnSwitchChange={OnSwitchChange}
                />
              )}
            </div>
            {(isMobile || isLandscape) && (
              <div className="p-10">
                <div className={`${styles.mainDivs} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                  {filteredList?.map((record, _index) => {
                    return (
                      <MobileViewClientTable
                        client={record}
                        OnSwitchChange={OnSwitchChange}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default Clients;
